import { JsonapiEntity, attribute, entity, meta } from 'jsonapi-transformers';

import { Loadable } from '®shared/data';

import { CatalogueView } from './catalogue-view';
import { LibraryLocation } from './library-location';

@entity({ type: 'library_holdings' })
export class LibraryAvailability extends JsonapiEntity<LibraryAvailability> {
  @attribute() library_view_url: string;
  @attribute() library_search_url: string;
  @attribute() locations: LibraryLocation[];

  @meta() catalogues: CatalogueView[];
}

export interface LoadableLibraryAvailability
  extends Loadable<LibraryAvailability> {}
